import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormSubscription, GlobalFormsState } from './types';

const defaultState = (): GlobalFormsState => ({
  createVisit: [],
  editVisit: [],
  createMeeting: [],
  createEvent: [],
  editPatient: [],
  createPatient: [],
  createUser: [],
  editUser: [],
  createRole: [],
  editRole: [],
  createRoleWithGroups: [],
  editRoleWithGroups: [],
  createSubtenant: [],
  editSubtenant: [],
  importFromMiniscreen: [],
  importFromPts: [],
  createDoctor: [],
  editDoctor: [],
  createDataBlockType: [],
  createDataBlockField: [],
  editDataBlockField: [],
  editDataBlock: [],
  createDataBlock: [],
  createAppointmentColorSettings: [],
  editAppointmentColorSettings: [],
  hl7Filter: [],
  createResource: [],
  editResource: [],
  changeOwnPassword: [],
  changeLanguage: [],
  setPassword: [],
  importDocument: [],
  importMeasurementFiles: [],
  importPtsFiles: [],
  importGDTFile: [],
  mergeField: [],
  createDictionaryRecord: [],
  editDictionaryRecord: [],
  configureCustomDictionary: [],
  editResourceSettings: [],
  createCustomDictionaryItem: [],
  editCustomDictionaryItem: [],
  createCalendarConfiguration: [],
  editCalendarConfiguration: [],
  createPatientListConfiguration: [],
  editPatientListConfiguration: [],
  mergePair: [],
  manageGDTMappings: [],
  sendViaGDT: [],
  selectVisits: [],
  createAbsence: [],
  editAbsence: [],
  createNote: [],
  editNote: [],
  fileVersionHistory: [],
  editDataBlockStatistic: [],
  createDataBlockStatistic: [],
  createVisitType: [],
  editVisitType: [],
  editInputTemplates: [],
  reimportMeasurements: [],
  mergePatientWithCardData: [],
  mergeInsuranceCardData: [],
  selectPatientForUpdateWithCardData: [],
  copyDataBlockFieldValue: [],
  createCodePrefix: [],
  sendTestMessage: [],
  movePatients: [],
});

export const globalFormsSlice = createSlice({
  name: 'globalForms',
  initialState: defaultState(),
  reducers: {
    addSubscription: (
      state,
      action: PayloadAction<FormSubscription>,
    ): GlobalFormsState => {
      const newSubscription = action.payload;
      const subscriptionsForForm = state[newSubscription.formType];
      state[newSubscription.formType] = [
        ...subscriptionsForForm.filter(
          (subscription) => subscription.id !== newSubscription.id,
        ),
        newSubscription,
      ];
      return state;
    },
    removeSubscription: (
      state,
      action: PayloadAction<FormSubscription>,
    ): GlobalFormsState => {
      const subscriptionToDelete = action.payload;
      const subscriptionsForForm = state[subscriptionToDelete.formType];
      state[subscriptionToDelete.formType] = [
        ...subscriptionsForForm.filter(
          (subscription) => subscription.id !== subscriptionToDelete.id,
        ),
      ];
      return state;
    },
  },
});

export const GlobalFormsActions = globalFormsSlice.actions;
